import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Events from "@/pages/Events";

export const Route = createFileRoute("/es/eventos/")({
  head: () => buildRouteHead("/es/eventos"),
  component: Events,
});

